import { NavLink, Outlet} from 'react-router'
import styles from './SideBarLayout.module.css'
import type { ReactNode } from 'react';

type Link = {
    label: string
    path: string
    icon?: ReactNode
}

type Props = {
    links: Link[]
    children?: ReactNode
}

export default function SideBarLayout( { links, children } : Props) {

  return (
    <aside className={styles.container}>
        <div className={styles.sidebar}>
            { links.map(({label, path, icon: Icon}) => (         
                <NavLink 
                    key={`link-${path}`}
                    to={`${path}`}                     
                    className={({isActive}) => `${styles.barlink} ${isActive ? styles.active : ""}`}                
                >                        
                    {Icon}                        
                    <span>{label}</span>
                </NavLink>                
             )
            )}
        </div>

        <div className={styles.outlet}>
            {children ?? <Outlet />}            
        </div>
    </aside>
  )
}
